module.exports = __webpack_public_path__ + "media/5.0728dc9e.mp3";